import { ComponentType } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Handle, type NodeProps, Position } from '@xyflow/react'

import { useAutoMeasureNode } from 'modules/workflows/lib/useAutoMeasureNode'

import { FlowNodeAddButton } from './FlowNodeAddButton'
import { FlowNodeApproval } from './FlowNodeApproval'
import { FlowNodeConditionDefault } from './FlowNodeConditionDefault'
import { FlowNodeMultiAction } from './FlowNodeMultiAction'
import { FlowNodeNotification } from './FlowNodeNotification'
import { FlowNodeSwitch } from './FlowNodeSwitch'
import { FlowNodeSwitchCondition } from './FlowNodeSwitchCondition'
import { FlowNodeTask } from './FlowNodeTask'
import { FlowNodeTerminate } from './FlowNodeTerminate'
import { FlowNodeTrigger } from './FlowNodeTrigger'
import { NodeUI, NodeUIType } from './types'
import { hasBottomConnection, hasTopConnection } from './utils'

const components: Partial<Record<NodeUIType, ComponentType<NodeProps<NodeUI>>>> = {
  trigger: FlowNodeTrigger,
  // notification: FlowNodeNotification,
  task: FlowNodeTask,
  approvals: FlowNodeApproval,
  condition: FlowNodeSwitch,
  conditionIf: FlowNodeSwitchCondition,
  conditionElse: FlowNodeConditionDefault,
  terminate: FlowNodeTerminate,
  multiAction: FlowNodeMultiAction,
}

const getComponentForNode = (node: NodeProps<NodeUI>): ComponentType<NodeProps<NodeUI>> | null => {
  return components[node.type] || null
}

export const FlowNode = (props: NodeProps<NodeUI>) => {
  const { containerRef } = useAutoMeasureNode(props.id)
  const Component = getComponentForNode(props)
  const conectorStyle = {
    background: 'white',
    border: '2px solid #CECECE',
    height: '10px',
    width: '10px',
  }
  const topConectorSytle = {
    ...conectorStyle,
    ...(!hasTopConnection(props.type) ? { top: '10px', opacity: 0 } : { top: '30px' }),
  }
  const bottomConectorStyle = {
    ...conectorStyle,
    ...(!hasBottomConnection(props.type) ? { opacity: 0, bottom: '10px' } : {}),
  }

  if (!Component) {
    return <Box ref={containerRef}>{props.type}</Box>
  }

  // Just to avoid orphan detector on CI
  if (false) return <FlowNodeNotification {...props} />

  return (
    <Box ref={containerRef}>
      {props.type !== 'trigger' && (
        <Handle
          style={topConectorSytle}
          type="target"
          position={Position.Top}
          isConnectable={hasTopConnection(props.type)}
        />
      )}
      <Component {...props} />
      <FlowNodeAddButton nodeId={props.id} nodeType={props.type} />
      <Handle
        type="source"
        style={bottomConectorStyle}
        position={Position.Bottom}
        isConnectable={hasBottomConnection(props.type)}
      />
    </Box>
  )
}
